import { StyleSheet, ViewStyle, TextStyle, ImageStyle } from 'react-native';

interface Styles {
  container: ViewStyle;
  sider: ViewStyle;
  logo: ViewStyle;
  logoImage: ImageStyle;
  logoTitle: TextStyle;
  logoSubtitle: TextStyle;
  menu: ViewStyle;
  menuItem: ViewStyle;
  menuItemSelected: ViewStyle;
  menuIcon: TextStyle;
  menuText: TextStyle;
  menuTextSelected: TextStyle;
  layout: ViewStyle;
  header: ViewStyle;
  headerTitle: TextStyle;
  content: ViewStyle;
}

export default StyleSheet.create<Styles>({
  container: {
    flex: 1,
    flexDirection: 'row',
    minHeight: '100%' as any,
    backgroundColor: '#f0f2f5',
  },
  sider: {
    width: 250,
    backgroundColor: '#001529',
    paddingTop: 0,
  },
  logo: {
    padding: 16,
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.05)',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.1)',
  },
  logoImage: {
    width: 40,
    height: 40,
    marginBottom: 8,
  },
  logoTitle: {
    color: 'white',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 4,
  },  logoSubtitle: {
    color: '#ccc',
    fontSize: 12,
  },
  menu: {
    paddingTop: 16,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
  menuItemSelected: {
    backgroundColor: '#1890ff',
  },
  menuIcon: {
    fontSize: 18,
    marginRight: 12,
  },
  menuText: {
    color: 'rgba(255,255,255,0.65)',
    fontSize: 14,
  },
  menuTextSelected: {
    color: 'white',
  },
  layout: {
    flex: 1,
    backgroundColor: '#f0f2f5',  },
  header: {
    backgroundColor: '#fff',
    paddingHorizontal: 24,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '500',
    color: '#000',
  },
  content: {
    flex: 1,
    backgroundColor: '#f0f2f5',
  },
});